import {
  Modal,
  PrimaryButton,
  BasicButton,
  Stack,
  Text,
} from "@certn/cascadia";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Select,
  SelectItem,
} from "@certn/cascadia-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { EmploymentVerificationRuleset } from "../types/form-values";

type SelectedValues = {
  one_instance: string;
  two_or_more_instances: string;
};

interface MismatchModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (selectedValues: SelectedValues, type: string) => void;
  mismatchCountData?: EmploymentVerificationRuleset["mismatch_count"];
}

export function MismatchModal({
  isOpen,
  onClose,
  onSave,
  mismatchCountData,
}: MismatchModalProps) {
  const { t } = useTranslation();
  const [selectedValues, setSelectedValues] = useState<SelectedValues>({
    one_instance: mismatchCountData?.one_instance || "REVIEW",
    two_or_more_instances: mismatchCountData?.two_or_more_instances || "REVIEW",
  });
  return (
    <Modal isOpen={isOpen} testID="mismatch-modal">
      <Dialog width="480px">
        <DialogHeader onClose={onClose}>{t("Mismatch outcome")}</DialogHeader>
        <DialogContent>
          <Stack gap="space-4">
            <Text style="global/body-primary">
              {t(
                "Set outcomes based on whether any discrepancies are found across claimed employments (e.g., job title, dates, employer)."
              )}
            </Text>
            <Select
              label={t("1 Mismatch")}
              testID="1-mismatch-outcome-select"
              selectedKey={selectedValues.one_instance}
              onSelectionChange={(value) =>
                setSelectedValues({
                  ...selectedValues,
                  one_instance: value as string,
                })
              }
            >
              <SelectItem id="REVIEW">{t("Review")}</SelectItem>
              <SelectItem id="CLEAR">{t("Clear")}</SelectItem>
              <SelectItem id="CRITERIA_NOT_MET">
                {t("Does not meet")}
              </SelectItem>
            </Select>
            <Select
              label={t("2+ Mismatches")}
              testID="2-or-more-mismatches-outcome-select"
              selectedKey={selectedValues.two_or_more_instances}
              onSelectionChange={(value) =>
                setSelectedValues({
                  ...selectedValues,
                  two_or_more_instances: value as string,
                })
              }
            >
              <SelectItem id="REVIEW">{t("Review")}</SelectItem>
              <SelectItem id="CLEAR">{t("Clear")}</SelectItem>
              <SelectItem id="CRITERIA_NOT_MET">
                {t("Does not meet")}
              </SelectItem>
            </Select>
          </Stack>
        </DialogContent>
        <DialogFooter>
          <BasicButton onPress={onClose} testID="cancel-button">
            {t("Cancel")}
          </BasicButton>
          <PrimaryButton
            onPress={() => {
              onSave(selectedValues, "mismatch_count");
              onClose();
            }}
            testID="save-button"
          >
            {t("Set")}
          </PrimaryButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
